<section class="verificacao-seguranca">
  <div class="verificacao-seguranca__box">
    <ng-container *ngIf="statusVerificacao === 5">
      <app-capture-selfie-verificacao
        (capture)="capturePhoto($event)"
        (backStep)="onClickErroWebcam()" >
      </app-capture-selfie-verificacao>
    </ng-container>
    <ng-container *ngIf="statusVerificacao !== 5">
      <div class="verificacao-seguranca__header" *ngIf="statusVerificacao !== 6">
        <img src="assets/images/logo_omni_dark_novo.svg" width="120" alt="logo">
      </div>

      <div class="verificacao-seguranca__content" [ngSwitch]="statusVerificacao">
        <app-bem-vindo *ngSwitchCase="1"></app-bem-vindo>
        <app-verificacao-seguranca-identificacao (cpf)="changeCpf($event)" *ngSwitchCase="1.1"></app-verificacao-seguranca-identificacao>
        <app-verificar *ngSwitchCase="2"></app-verificar>
        <app-concluido *ngSwitchCase="3"></app-concluido>
        <app-before-selfie *ngSwitchCase="4"></app-before-selfie>
        <app-after-selfie *ngSwitchCase="6" [foto]="foto"></app-after-selfie>
      </div>

      <div class="verificacao-seguranca__footer">
        <div>
          <button
            *ngIf="status === 6"
            class="btn btn-border-orange verificacao-seguranca__footer_dica-selfie"
            (click)="onClickPickNewPhoto()"
            [disabled]="loadingSaveSelf"
            type="button">
            <label>TIRAR OUTRA FOTO</label>
          </button>
        </div>

        <div>
          <button
            *ngIf="status === 4"
            class="btn btn-border-orange verificacao-seguranca__footer_dica-selfie"
            (click)="onClickDicaFotoSelfie()"
            type="button">
            <label>VER DICAS PARA A FOTO</label>
          </button>
        </div>

        <app-gradient-button
          *ngIf="getLabel()"
          [label]="getLabel()"
          [isDisabled]="isDisabledButtonClick"
          (click)="onClick()">
        </app-gradient-button>

        <a
          class="verificacao-seguranca__footer_termos"
          *ngIf="status === 2"
          (click)="onClickTermos()">
          Ver condições
        </a>
      </div>
    </ng-container>
  </div>
</section>

<app-loader-circles *ngIf="isLoading"></app-loader-circles>
